export default "__VITE_ASSET__BuJStd0n__"